var router = require('pjax').Router;
var chaptersIndex = require('./index.js');
var form = require('./form.js');

router.get('chapter/:any', form);
router.get('chapter', chaptersIndex);
